export default class Translator {
    // eslint-disable-next-line no-useless-constructor
    constructor (public readonly translations: {[key: string]: string}) {}

    public get locale (): string {
        return document.querySelector('html').getAttribute('lang');
    }

    public translate (key: string): string {
        return this.translations[key] || key;
    }

    /**
     * Picks a plural form from a Symfony-style message ("one|few|many") and replaces %count%.
     * Mirrors Symfony TranslatorTrait for whitelisted app locales; interval syntax ({0}, [1,Inf[) is not supported.
     */
    public choice (message: string, count: number, locale: string = this.locale): string {
        const forms = message.split('|').map((form) => {
            if (/^\s*[{\[\]]/.test(form)) {
                console.warn('Translator.choice: interval plural syntax is not supported.', message);
            }
            const label = form.match(/^\w+:\s*(.*)$/);
            return label ? label[1] : form;
        });

        const form = forms[Translator.pluralIndex(count, locale)] ?? forms[0];

        return form.split('%count%').join(String(count));
    }

    private static pluralIndex (count: number, locale: string): number {
        const n = Math.abs(count);

        switch (locale.split(/[_-]/)[0]) {
            case 'cs':
            case 'sk':
                return n === 1 ? 0 : (n >= 2 && n <= 4 ? 1 : 2);
            case 'de':
            case 'en':
            case 'hu':
            case 'nb':
            case 'no':
                return n === 1 ? 0 : 1;
            default:
                return 0;
        }
    }
}
